import type { ComponentPropsWithRef } from "react";
import { Fragment, forwardRef } from "react";
import { Section, Text } from "@react-email/components";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useParseStyles } from "../../../Design/useParseStyles";
import { p1DefaultStyles as defaultStyles } from "./defaultStyles";

export type ParagraphStyle = "p1" | "p2" | "p3";

interface PProps extends ComponentPropsWithRef<"table"> {
  styles?: Record<string, StyleValue>;
  text: string;
}

export const P = forwardRef<HTMLTableElement, PProps>(
  ({ text, styles = {}, ...rest }, ref) => {
    const inlineStyles = useParseStyles({
      styles,
      defaultStyles,
    });

    const formattedText = text.split("\n").map((line, index, array) =>
      index === array.length - 1 ? (
        line
      ) : (
        // eslint-disable-next-line react/no-array-index-key -- Using index is safe here as text lines don't reorder
        <Fragment key={index}>
          {line}
          <br />
        </Fragment>
      ),
    );

    return (
      <Section ref={ref} {...rest}>
        <Text style={inlineStyles}>{formattedText}</Text>
      </Section>
    );
  },
);

P.displayName = "P";
